import React, { useEffect, useState } from 'react';

const tickerItems = [
  { icon: 'bxs-star', text: 'تقييم 4.9/5' },
  { icon: 'bxs-check-circle', text: 'إشارات موثوقة' },
  { icon: 'bx-group', text: '3000+ متداولين نشطين' },
  { icon: 'bx-bullseye', text: 'دقة: 92%' },
  { icon: 'bx-gift', text: 'مجموعات إشارات مجانية' },
  { icon: 'bx-trending-up', text: 'تحليل يومي للسوق' },
  { icon: 'bx-headphone', text: 'دعم فني على مدار الساعة' },
  { icon: 'bx-shield-quarter', text: 'تعامل آمن وموثوق' },
  { icon: 'bx-badge-check', text: 'سمعتنا' },
];

export default function TopInfoBar() {
  const [visible, setVisible] = useState(false);

  // يظهر بعد السبلاتشر مباشرة (تأخير بسيط لمزامنة الانتقال)
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500); 
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 h-[46px] 
      bg-[rgba(34,255,155,0.06)] text-[#22ff9b] 
      flex items-center font-bold px-4 z-[10010] 
      border-b border-[rgba(34,255,155,0.12)] 
      backdrop-blur-sm shadow-[0_0_12px_rgba(34,255,155,0.03)] 
      text-[13px] overflow-hidden">

      <div className="relative w-full">
        <div className="whitespace-nowrap animate-tickerScroll will-change-transform">
          {[...tickerItems, ...tickerItems, ...tickerItems].map((item, index) => (
            <span key={index} className="inline-block mx-[34px] align-middle">
              <i className={`bx ${item.icon} ml-2 text-[#22ff9b] text-base align-middle`}></i>
              {item.text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
